module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.app) ? _c('div', {
    staticClass: "block-testimonial"
  }, [_c('div', {
    staticClass: "block-testimonial__quote-icon"
  }, [_c('Icon', {
    attrs: {
      "name": "quotes"
    }
  })], 1), _c('div', {
    staticClass: "block-testimonial__container"
  }, [_c('carousel', {
    attrs: {
      "autoplay": true,
      "autoplayTimeout": 7000,
      "perPage": 1,
      "loop": true,
      "speed": 700,
      "paginationEnabled": false,
      "navigationEnabled": true,
      "navigationNextLabel": _vm.arrowRight,
      "navigationPrevLabel": _vm.arrowLeft
    }
  }, _vm._l((_vm.app.acf.testimonials), function(quote, i) {
    return _c('slide', {
      key: i
    }, [_c('div', {
      staticClass: "block-testimonial__quote",
      domProps: {
        "innerHTML": _vm._s(quote.content)
      }
    }), (quote.author) ? _c('div', {
      staticClass: "block-testimonial__author",
      domProps: {
        "innerHTML": _vm._s(quote.author)
      }
    }) : _vm._e()])
  }))], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b7e4ea4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-testimonial/block-testimonial.pug
// module id = 563
// module chunks = 1